<mat-card *ngIf="(isLoaded$ | async) === true">
  <!-- TODO Visszatenni, ha kell a publikus mező szerkesztés -->

  <!--mat-card-title-group>
      <mat-checkbox
        class="easy-checkbox ms-auto"
        (change)="showVisibleFields = $event.checked"
        [checked]="showVisibleFields"
      >
        {{ "SHARED.VISIBLE_FIELDS.TOGGLE" | translate }}
      </mat-checkbox>
    </mat-card-title-group-->

  <form
    class="easy-form"
    [formGroup]="form"
    appScrollToInvalidControl
    [appEditableWithRole]="['MERCHANT_ADMIN']"
  >
    <fieldset
      class="in-one-column"
      [class.with-visible-fields]="showVisibleFields"
    >
      <!-- emails -->

      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="emails"
      ></app-visible-fields-checkbox>
      <app-localized-key-value-pairs-subform
        class="w-100"
        [title]="TITLE + 'EMAILS'"
        formArrayName="emails"
        keyControlName="email"
        [keyControlValidators]="emailSubformValidators"
        [keyControlValidatorMessage]="HINT + 'email'"
        [keyControlTitle]="TITLE + 'email'"
      ></app-localized-key-value-pairs-subform>

      <!-- phones -->

      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="phones"
      ></app-visible-fields-checkbox>
      <app-localized-key-value-pairs-subform
        class="w-100"
        [keyIsPhoneNumber]="true"
        [title]="TITLE + 'PHONES'"
        formArrayName="phones"
        keyControlName="phone"
        [keyControlValidators]="phoneSubformValidators"
        [keyControlValidatorMessage]="HINT + 'phone'"
        [keyControlTitle]="TITLE + 'phone'"
      ></app-localized-key-value-pairs-subform>
    </fieldset>

    <fieldset
      class="in-one-column"
      [class.with-visible-fields]="showVisibleFields"
    >
      <legend>{{ "MERCHANT.TITLE.CONTACT_ADDRESS" | translate }}:</legend>

      <!-- postalAddress -->

      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="postalAddress"
      ></app-visible-fields-checkbox>
      <app-easy-address-subform
        title="{{ TITLE + 'ADDRESS' }}"
        groupName="postalAddress"
        [basicDataAddress]="(basicDataAddress$ | async) ?? undefined"
        [showCopyBasicDataButton]="true"
      >
      </app-easy-address-subform>
    </fieldset>

    <fieldset
      class="in-one-column"
      [class.with-visible-fields]="showVisibleFields"
    >
      <legend>{{ "MERCHANT.TITLE.OPENING_HOURS" | translate }}:</legend>

      <!-- openingHours -->

      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="openingHours"
      ></app-visible-fields-checkbox>
      <app-easy-opening-hours-subform
        class="w-100"
        formGroupName="openingHours"
      ></app-easy-opening-hours-subform>

      <!-- others -->

      <app-visible-fields-checkbox
        class="margin-top"
        *ngIf="showVisibleFields"
        fieldName="others"
      ></app-visible-fields-checkbox>
      <app-other-contacts-subform
        title="{{ TITLE + 'OTHERS' }}"
        formGroupName="others"
      ></app-other-contacts-subform>
    </fieldset>

    <div class="button-row">
      <button type="button" mat-raised-button (click)="onLoad()">
        {{ "MERCHANT.BTN.CANCEL" | translate | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="onSubmit()">
        {{ "MERCHANT.BTN.UPDATE" | translate | uppercase }}
      </button>
    </div>
  </form>
</mat-card>
